export const CategoriesEnum = Object.freeze({
  COLECAO: 'COLECAO',
  VITRINE: 'VITRINE',
});
